module.exports = __webpack_public_path__ + "dashboard/img/radio-12.9b60cef949ec7f786b0da2fa6efc90b0.svg";